import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getTemperatureLayout(
  _datapoints,
  showTitle = true,
  small = false,
) {
  const datapoints = orderByDate(_datapoints);
  const color = "#f99";
  let layout = {
    interactivityEnabled: false,
    theme: "light2",
    title: {
      text: showTitle ? `Grafico ultime ${datapoints.length} temperature` : "",
    },
    axisY: {
      minimum: 35,
      gridThickness: 0.6,
      maximum: 40,
      interval: 0.5,
    },
    axisX: {
      labelFontSize: small ? 10 : 16,
      labelMaxWidth: small ? 45 : 60,
      stripLines: [],
      gridThickness: 0,
      labelTextAlign: "center",
      labelFormatter: function (e) {
        return CanvasJSReact.CanvasJS.formatDate(e.label, "DD/MM YYYY HH:mm");
      },
    },

    data: [
      {
        type: "area",
        color: "#f99",
        markerColor: "#ff0000",
        dataPoints: datapoints.map((el) => {
          return {
            label: el.x,
            y: el.y,
          };
        }),
      },
    ],
  };

  return layout;
}

export function generateTemperatureChart(reports, small = false) {
  const datapoints = parseTemperatureReports(reports);

  // genero il report
  const layout = getTemperatureLayout(datapoints, false, small);
  return layout;
}

export function parseTemperatureReports(measures) {
  let datapoints = [];

  // prendo le misurazioni di temperatura + data
  measures.forEach((report, index) => {
    if (report.data.Temperature !== null)
      datapoints.push({
        x: report.data.Date,
        y: eval(report.data.Temperature),
      });
  });

  return datapoints;
}
